const LeaseToOwnStyles = {
  container: {
    backgroundColor: '#f4f4f9',
    padding: '80px 20px',
    textAlign: 'center',
  },
  title: {
    fontWeight: '700',
    fontSize: '3rem',
    color: '#333333',
    marginBottom: '20px',
  },
  description: {
    fontSize: '1.2rem',
    color: '#555555',
    maxWidth: '800px',
    margin: '0 auto 40px',
    lineHeight: '1.8',
    textAlign: 'center',
  },
  form: {
    maxWidth: '800px',
    margin: '0 auto',
    backgroundColor: '#ffffff',
    padding: '50px',
    borderRadius: '15px',
    boxShadow: '0px 8px 20px rgba(0, 0, 0, 0.15)',
  },
  input: {
    marginBottom: '25px',
  },
  sectionTitle: {
    fontWeight: 'bold',
    fontSize: '1.8rem',
    color: '#333333',
    marginTop: '40px',
    marginBottom: '20px',
  },
  buttonContainer: {
    marginTop: '30px',
  },
  submitButton: {
    width: '100%',
    padding: '15px',
    fontSize: '1.3rem',
    fontWeight: 'bold',
    backgroundColor: '#81c241',
    color: '#fff',
    textTransform: 'uppercase',
    borderRadius: '8px',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: '#6aa832',
      transform: 'scale(1.02)',
    },
  },
  printButton: {
    width: '100%',
    padding: '15px',
    fontSize: '1.3rem',
    fontWeight: 'bold',
    borderColor: '#81c241',
    color: '#81c241',
    textTransform: 'uppercase',
    borderRadius: '8px',
    transition: 'all 0.3s ease',
    '&:hover': {
      borderColor: '#6aa832',
      color: '#6aa832',
      transform: 'scale(1.02)',
    },
  },
};

export default LeaseToOwnStyles;

